import * as React from "react";

const IconHeaderCaretRight: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="currentColor"><polygon fill="currentColor" points="6.232 5.302 5.767 5.767 1.395 10.142 .93 10.607 .003 9.677 .468 9.212 4.378 5.302 .465 1.392 0 .927 .93 0 1.395 .465 5.77 4.837 6.234 5.302" transform="translate(.945 .448)"/></svg>;
};

export default React.memo(IconHeaderCaretRight);
